var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      fill: "#ee342e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.334 54.505c0 1.888.304 3.45.911 4.688 1.129 2.278 3.18 3.418 6.153 3.418 1.823 0 3.412-.624 4.769-1.872 1.356-1.248 2.034-3.044 2.034-5.387 0-3.104-1.258-5.176-3.776-6.218-1.432-.586-3.69-.879-6.77-.879v-6.64c3.016-.044 5.12-.337 6.314-.88 2.062-.91 3.093-2.755 3.093-5.533 0-1.801-.526-3.266-1.579-4.395-1.052-1.128-2.534-1.692-4.443-1.692-2.192 0-3.803.694-4.834 2.083-1.031 1.389-1.525 3.244-1.481 5.566h-8.66c.088-2.343.489-4.568 1.205-6.673.76-1.845 1.953-3.548 3.58-5.11 1.216-1.107 2.66-1.954 4.33-2.54 1.671-.585 3.722-.878 6.153-.878 4.514 0 8.154 1.166 10.92 3.499 2.768 2.333 4.151 5.463 4.151 9.391 0 2.778-.824 5.122-2.474 7.031-1.041 1.194-2.126 2.008-3.255 2.442.847 0 2.062.727 3.646 2.18 2.365 2.193 3.548 5.187 3.548 8.985 0 3.993-1.383 7.503-4.15 10.53-2.767 3.028-6.863 4.542-12.289 4.542-6.684 0-11.328-2.181-13.932-6.543-1.367-2.322-2.127-5.36-2.279-9.115h9.115Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.acc64b7b732c8cd0938de33721342753.svg";
export { ForwardRef as ReactComponent };